import { createAction, props } from '@ngrx/store';

export const SetFilters = createAction(
  '[Shipments] Set Filters',
  props<{ filters: any }>()
);
export const SetFilterCount = createAction(
  '[Shipments] Set Filter Count',
  props<{ count: number }>()
);

export const ClearFilters = createAction('[Shipments] Clear Filters');
